
import api from '@/api'

// 代理商后台--代理商登录
export function login(data) {
    return api({
        url: '/agent/admin/login',
        method: 'post',
        data
    })
}

// 登录（密码）
export function getPermission(params) {
    return api({
        url: '/system/getInfo',
        method: 'get',
        params
    })
}

